module.exports = {
  "header": [
    {
      "type": "image",
      "id": "design_header_0",
      "config": {
        "src": "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
        "width": "600"
      },
      "align": "center"
    }
  ],
  "body": [
    {
      "type": "text",
      "id": "design_body_0",
      "config": {
        "text": "<h1 style=\"color: #0f5132; font-family: 'Helvetica Neue', Arial, sans-serif; margin: 0 0 8px;\">Introducing Smart Analytics</h1>\n<p style=\"color: #4a4a4a; font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 16px; line-height: 1.6; margin: 0 0 24px;\">Our latest release brings real-time dashboards, custom reports, and predictive insights to help your team make faster, data-driven decisions. Upgrade today and see the difference.</p>"
      },
      "edit": "<h1 style=\"color: #0f5132; font-family: 'Helvetica Neue', Arial, sans-serif; margin: 0 0 8px;\">Introducing Smart Analytics</h1>\n<p style=\"color: #4a4a4a; font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 16px; line-height: 1.6; margin: 0 0 24px;\">Our latest release brings real-time dashboards, custom reports, and predictive insights to help your team make faster, data-driven decisions. Upgrade today and see the difference.</p>",
      "align": "center"
    },
    {
      "type": "text",
      "id": "design_body_1",
      "config": {
        "text": "<div style=\"text-align: center; margin: 24px 0;\">\n  <a href=\"#\" style=\"background-color: #0f5132; color: #ffffff; padding: 12px 28px; text-decoration: none; border-radius: 4px; font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 14px; font-weight: bold; display: inline-block;\">See What's New</a>\n</div>"
      },
      "edit": "<div style=\"text-align: center; margin: 24px 0;\">\n  <a href=\"#\" style=\"background-color: #0f5132; color: #ffffff; padding: 12px 28px; text-decoration: none; border-radius: 4px; font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 14px; font-weight: bold; display: inline-block;\">See What's New</a>\n</div>",
      "align": "center"
    }
  ],
  "footer": [
    {
      "type": "text",
      "id": "design_footer_0",
      "config": {
        "text": "<hr style=\"border: none; border-top: 1px solid #e0e0e0; margin: 24px 0;\">\n<p style=\"font-size: 12px; color: #9a9a9a; font-family: 'Helvetica Neue', Arial, sans-serif; text-align: center; line-height: 1.6;\">\n  Acme Inc. &middot; 123 Business Avenue, Suite 100, San Francisco, CA 94107<br>\n  <a href=\"#\" style=\"color: #9a9a9a; text-decoration: underline;\">Unsubscribe</a> &middot; <a href=\"#\" style=\"color: #9a9a9a; text-decoration: underline;\">View in browser</a> &middot; &copy; 2026 Acme Inc.\n</p>"
      },
      "edit": "<hr style=\"border: none; border-top: 1px solid #e0e0e0; margin: 24px 0;\">\n<p style=\"font-size: 12px; color: #9a9a9a; font-family: 'Helvetica Neue', Arial, sans-serif; text-align: center; line-height: 1.6;\">\n  Acme Inc. &middot; 123 Business Avenue, Suite 100, San Francisco, CA 94107<br>\n  <a href=\"#\" style=\"color: #9a9a9a; text-decoration: underline;\">Unsubscribe</a> &middot; <a href=\"#\" style=\"color: #9a9a9a; text-decoration: underline;\">View in browser</a> &middot; &copy; 2026 Acme Inc.\n</p>",
      "align": "center"
    }
  ],
  "id": "product_announcement"
};
